import React from 'react';
import PropTypes from 'prop-types';

import Cleave from 'cleave.js/react';

const options = { date: true, datePattern: ['m', 'Y'] };

const CreditCardExpiryField = ({ field, ...props }) => (
  <Cleave options={options} {...field} {...props} />
);

CreditCardExpiryField.propTypes = {
  field: PropTypes.object.isRequired,
};

export default CreditCardExpiryField;
